/* SOFIZARE – snel bestellen op productkaarten (v3). Event delegation: werkt ook na filteren/paginatie.
   Foto-swatches + optie-select -> juiste variant, SKU, knopstatus en kaartfoto. Melding komt van Focal zelf. */
(function(){
  function T(box,k,f){return (box&&box.dataset['szT'+k])||f;}
  function snap(input){
    var min=parseInt(input.min,10)||1, step=parseInt(input.step,10)||1, v=parseInt(input.value,10);
    if(isNaN(v)||v<min) v=min;
    input.value=min+Math.round((v-min)/step)*step;
  }
  function variants(box){
    if(!box._szv){var s=box.querySelector('[data-sz-variants]');try{box._szv=s?JSON.parse(s.textContent):[];}catch(e){box._szv=[];}}
    return box._szv;
  }
  function selected(box){
    var sel=[];
    var sw=box.querySelector('.sz-qty__swatches');
    if(sw){var b=sw.querySelector('.sz-qty__swatch.is-selected');sel[+sw.dataset.szOpt]=b?b.dataset.szValue:null;}
    box.querySelectorAll('.sz-qty__optselect').forEach(function(s){sel[+s.dataset.szOpt]=s.value;});
    return sel;
  }
  function update(box){
    var vs=variants(box); if(!vs.length) return;
    var sel=selected(box), v=null;
    for(var i=0;i<vs.length;i++){var ok=true;for(var k=0;k<sel.length;k++){if(sel[k]!=null&&vs[i].o[k]!==sel[k]){ok=false;break;}}if(ok){v=vs[i];break;}}
    var add=box.querySelector('[data-sz-add]'), lbl=box.querySelector('[data-sz-add-label]'), input=box.querySelector('.sz-qty__input');
    var SOLD=T(box,'Sold','Sold out'), ADD=T(box,'Add','Add'), ARIA=T(box,'AddAria','Add to cart');
    if(!v){add.disabled=true;lbl.textContent=SOLD;add.setAttribute('aria-label',SOLD);return;}
    box.querySelector('[data-sz-id]').value=v.id;
    box.querySelector('[data-sz-sku]').textContent=v.sku?(T(box,'Sku','SKU')+': '+v.sku):'\u00a0';
    input.min=v.min||1;input.step=v.step||1;snap(input);
    add.disabled=!v.a; lbl.textContent=v.a?ADD:SOLD;
    add.setAttribute('aria-label',v.a?ARIA:SOLD);
    if(v.img) swapImage(box,v.img);
  }
  function swapImage(box,img){
    var card=box.closest('.product-item'); if(!card) return;
    var wrap=card.querySelector('.product-item__image-wrapper');
    var prim=card.querySelector('.product-item__primary-image:not([hidden])')||card.querySelector('.product-item__primary-image');
    if(!prim) return;
    prim.removeAttribute('loading');
    prim.srcset=img.srcset; prim.src=img.src;
    if(wrap) wrap.classList.add('sz-variant-picked'); /* geen hover-foto meer van een andere variant */
  }
  document.addEventListener('click',function(e){
    var sw=e.target.closest('.sz-qty__swatch');
    if(sw){
      e.preventDefault(); if(sw.disabled) return;
      sw.parentNode.querySelectorAll('.sz-qty__swatch').forEach(function(b){b.classList.toggle('is-selected',b===sw);b.setAttribute('aria-checked',b===sw?'true':'false');});
      update(sw.closest('.sz-qty')); return;
    }
    var b=e.target.closest('[data-sz-minus],[data-sz-plus]'); if(!b) return;
    e.preventDefault();
    var input=b.closest('.sz-qty__stepper').querySelector('.sz-qty__input');
    var step=parseInt(input.step,10)||1;
    input.value=(parseInt(input.value,10)||0)+(b.hasAttribute('data-sz-plus')?step:-step);
    snap(input);
  });
  document.addEventListener('change',function(e){
    if(e.target.matches('.sz-qty__input')) snap(e.target);
    if(e.target.matches('.sz-qty__optselect')) update(e.target.closest('.sz-qty'));
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Enter'&&e.target.matches('.sz-qty__input')){e.preventDefault();snap(e.target);e.target.form.requestSubmit();}
  });
})();
